<template>
  <div>
    <title-screen title ="20"></title-screen>
    <div v-if="!!ankenId">
      <div class="anken-detail">
        <AnkenInfo :id="ankenId" :isNoticeHeritageDivision="isUpdateNotice" @ankenInfoLoad="ankenInfoLoad"></AnkenInfo>
      </div>
      <heritage-division id="heritage-division" :anken-id="ankenId" role="client"></heritage-division>
    </div>
  </div>
</template>

<script>
    import HeritageDivision from '../../share/16_heritagedivision/HeritageDivision'
    import AnkenInfo from '../38_anken/AnkenInfo'
    import TitleScreen from '../../../../components/common/TitleScreen'
    import { isIE } from '@/common/useragent'

    export default {
      name: 'HeritageDivisionPage',
      components: { TitleScreen, AnkenInfo, HeritageDivision },
      data () {
        return {
          ankenId: null,
          isAnkenInfoLoaded: false,
          isLoaded: false,
          isUpdateNotice: false,
          heirsUpdatedAt: null,
          propertiesUpdatedAt: null
        }
      },
      created () {
        this.ankenId = +this.$route.params.id
      },
      methods: {
        ankenInfoLoad (val) {
          this.isAnkenInfoLoaded = val
        },
        scrollDatePickerView () {
          if (this.isAnkenInfoLoaded && this.isLoaded) {
            this.$nextTick(() => {
                const ankenViews = document.getElementsByClassName('anken-info')
                if (ankenViews.length > 0) {
                    const ankenView = ankenViews[0]
                    if (ankenView) {
                        var navHeight = 0
                        if (window.innerWidth > 600 && window.innerHeight > 400 && window.scrollY < 170) {
                            const navViews = document.getElementsByClassName('gnav nav-height')
                            if (navViews.length > 0) {
                                const navView = navViews[0]
                                if (navView) {
                                    navHeight = navView.offsetHeight
                                    if (!isIE() && this._$(navView).css('position') === 'static') navHeight += 60
                                }
                            }
                        }
                        const scrollTop = ankenView.offsetTop + ankenView.offsetHeight - navHeight
                        window.scroll(0, scrollTop)
                    }
                }
            })
          }
        }
      },
      watch: {
        isAnkenInfoLoaded: function () {
          this.scrollDatePickerView()
        },
        isLoaded: function () {
          this.scrollDatePickerView()
        }
      }
    }
</script>

<style scoped>

</style>
